<div class="content-box">
  <app-breadcrumb pagina="Resultado da busca"></app-breadcrumb>
</div>

<div class="busca-hero">
  <div class="busca-hero-conteudo">
    <div class="busca-hero-texto">
      <span class="busca-hero-selo">
        <i-lucide name="search" size="15" aria-hidden="true"></i-lucide>
        Busca no portal
      </span>

      <h1 class="busca-hero-titulo">
        Resultado da busca <span>para você</span>
      </h1>

      <p class="busca-hero-descricao">
        Procuramos nos serviços, nas categorias, nas notícias e nas páginas do portal o que casa com o que
        você pesquisou.
      </p>

      @if (termo().trim()) {
      <p class="busca-hero-termo">
        Você buscou:
        <strong>{{ termo().trim() }}</strong>
      </p>
      }
    </div>

    <span class="busca-hero-orbe" aria-hidden="true">
      <i-lucide name="search" size="42"></i-lucide>
    </span>
  </div>
</div>

<div class="content-box">
  <app-input-buscar (buscar)="aoBuscar($event)"></app-input-buscar>

  <section class="busca" aria-labelledby="busca-resultados-titulo">

    @if (termoCurto()) {
    <div class="busca-vazio busca-estado">
      <p class="busca-vazio-texto">Digite ao menos {{ termoMinimo }} caracteres para buscar.</p>
    </div>
    } @else if (carregando()) {
    <div class="busca-vazio busca-estado" aria-live="polite">
      <p class="busca-vazio-texto">Buscando “{{ termo().trim() }}”…</p>
    </div>
    } @else {

    @if (falhou()) {
    <div class="busca-vazio busca-estado busca-falha" role="alert">
      <p class="busca-vazio-texto">
        Não foi possível consultar os serviços e as notícias agora. Tente novamente em instantes.
      </p>
      <button type="button" class="busca-vazio-botao" (click)="tentarNovamente()">Tentar novamente</button>
    </div>
    }

    <div class="busca-aviso">
      <p class="busca-aviso-texto">
        <i-lucide name="info" size="16" aria-hidden="true" color="#00E5FF"></i-lucide>
        {{ total() }} {{ total() === 1 ? 'resultado' : 'resultados' }} para “{{ termo().trim() }}”.
      </p>
    </div>

    <div class="busca-abas" role="group" aria-label="Filtrar resultados por canal">
      <button type="button" class="busca-aba busca-aba-todos" [class.busca-aba-ativa]="!canalAtivo()"
        [attr.aria-pressed]="!canalAtivo()" (click)="selecionarCanal('')">
        <i-lucide name="layout-grid" size="16" aria-hidden="true"></i-lucide>
        Todos
        <span class="busca-aba-total">{{ total() }}</span>
      </button>

      @for (canal of canais; track canal.id) {
      <button type="button" class="busca-aba" [class.busca-aba-ativa]="canalAtivo() === canal.id"
        [attr.aria-pressed]="canalAtivo() === canal.id" (click)="selecionarCanal(canal.id)">
        {{ canal.rotulo }}
        <span class="busca-aba-total">{{ totalDoCanal(canal.id) }}</span>
      </button>
      }
    </div>

    <h2 class="busca-titulo" id="busca-resultados-titulo">
      <i class="fa-solid fa-star busca-titulo-icone" aria-hidden="true"></i>
      Melhor resultado para você
    </h2>

    @if (resultadosDoCanal().length) {
    <ul class="busca-lista" #listaResultados>
      @for (resultado of resultadosDaPagina(); track resultado.id) {
      <li class="busca-card">
        <span class="busca-card-icone" aria-hidden="true">
          <i-lucide name="file-text" size="26"></i-lucide>
        </span>

        <div class="busca-card-conteudo">
          <div class="busca-card-selos">
            @if (resultado.maisRelevante) {
            <span class="busca-selo busca-selo-relevante">Mais relevante</span>
            }
            <span class="busca-selo busca-selo-canal">{{ rotuloCanal(resultado.canal) }}</span>
          </div>

          <h3 class="busca-card-titulo">{{ resultado.titulo }}</h3>
          <p class="busca-card-descricao">{{ resultado.descricao }}</p>

          @if (resultado.destaques.length) {
          <ul class="busca-card-destaques">
            @for (destaque of resultado.destaques; track destaque) {
            <li>{{ destaque }}</li>
            }
          </ul>
          }
        </div>

        <a class="busca-card-acesso" [routerLink]="resultado.link">
          <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
          Acessar resultado
        </a>
      </li>
      }
    </ul>

    @if (totalPaginas() > 1) {
    <app-paginacao rotulo="Paginação dos resultados da busca" [paginaAtual]="paginaAtual()"
      [totalPaginas]="totalPaginas()" (paginaMudou)="irParaPagina($event)"></app-paginacao>
    }
    } @else if (canalAtivo()) {
    <div class="busca-vazio">
      <p class="busca-vazio-texto">Nenhum resultado neste canal para a sua busca.</p>
      <button type="button" class="busca-vazio-botao" (click)="selecionarCanal('')">Ver todos os resultados</button>
    </div>
    } @else {
    <div class="busca-vazio">
      <p class="busca-vazio-texto">
        Nenhum resultado para “{{ termo().trim() }}”. Tente outra palavra, ou navegue pela lista completa.
      </p>
      <a class="busca-vazio-botao" routerLink="/servicos">Ver todos os serviços</a>
    </div>
    }
    }
  </section>
</div>
